import crudState from '../utils/crud/state'
import * as crudGetters from '../utils/crud/getters'
import * as crudMutations from '../utils/crud/mutations'
import * as crudActions from '../utils/crud/actions'
import get from 'lodash/get'

import moment from 'moment'
import groupBy from 'lodash/groupBy'
import range from 'lodash/range'
import map from 'lodash/map'

import axios from '@/plugins/axios'

import estados from './estados'
import tipos from './tipos'
import ejecutivo from './ejecutivo'
import tiempo from './tiempo'
import sinasignacion from './sinasignacion'
import calendario from './calendario'
import disponibilidad from './disponibilidad'
import { isArray } from 'lodash'

export default {
  namespaced: true,
  state: () => ({
    endpoint: 'fsactividad',
    ...crudState(),

    activeView: 2,
    dateFilter: moment().format('YYYY-MM-DD'),
    dateFilterRange: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    userAsignado: {},
    returnUser: false,
    siAsignarHasta: true
  }),
  getters: {
    ...crudGetters,
    activeView: state => state.activeView,
    dateFilter: state => state.dateFilter,
    dateFilterRange: state => state.dateFilterRange,
    userAsignado: state => state.userAsignado,
    returnUser: state => state.returnUser,
    siAsignarHasta: state => state.siAsignarHasta,

    agrupadoPorEjecutivo: state => map(groupBy(state.all, item => `${item.idusuarioasignado}||${item.idusuarioasignadodesc}`), (actividades, ejecutivo) => ({ ejecutivo_id: ejecutivo.split('||')[0], ejecutivo_desc: ejecutivo.split('||')[1], actividades })),
    horasEnUso: state => {
      const hours = state.all.reduce((old, current) => {
        const desde = moment(current.fechayhoraplanificaciondesde).format('HH')
        const hasta = moment(current.fechayhoraplanificacionhasta).format('HH')
        if (desde !== 'Invalid date' && !old.includes(desde)) {
          old.push(desde)
        }
        if (hasta !== 'Invalid date' && !old.includes(hasta)) {
          old.push(hasta)
        }

        return old
      }, []).sort()

      return range(parseInt(hours[0]), parseInt(hours[hours.length - 1]) + 1).map(item => `${item}:00`)
    },
    asignadas: state => state.all.filter(item => item.idestado !== 4),
    finalizadas: state => state.all.filter(item => item.idestado === 4),
    sinasignar: state => state.all.filter(item => !!item.idusuarioasignado)
  },
  mutations: {
    ...crudMutations,
    setActiveView (state, value) {
      state.activeView = value
    },
    setDateFilterRange (state, value) {
      state.dateFilterRange = value
    },
    setDateFilter (state, value) {
      state.dateFilter = value
    },
    setUserAsignado (state, value) {
      state.userAsignado = value
    },
    setReturnUser (state, value) {
      state.returnUser = value
    },
    setSiAsignarHasta (state, value) {
      state.siAsignarHasta = value
    }
  },
  actions: {
    ...crudActions,
    activateView ({ commit }, id) {
      commit('setActiveView', id)
    },
    moveDateFilter ({ commit, dispatch, state }, day) {
      commit('setDateFilter', moment(state.dateFilter).add(day, 'days').format('YYYY-MM-DD'))
    },
    async check ({ commit, state }, { idactividad, idtarea, value }) {
      const action = value ? 'done' : 'undone'
      try {
        await axios.post(`${state.endpoint}/${action}`, { idactividad, idtarea })

        return true
      } catch (e) {
        return Promise.reject(e)
      }
    },

    async saveCheck ({ commit, state }) {
      try {
        const response = await axios.put(`${state.endpoint}/upd/check`, state.one)
        const data = get(response, 'data.data', {})
        return data
      } catch (e) {
        return e
      }
    }
  },
  modules: {
    estados,
    tipos,
    ejecutivo,
    tiempo,
    sinasignacion,
    calendario,
    disponibilidad
  }
}
